import { GCNotification } from '@business/entities/notifications';

import { TimeLogId } from '../time_log';
import { OrgId } from '../organization';
import { JobResponse } from '../job';

export enum MessageKind {
  tracker = 'tracker',
  tasks = 'tasks',
  jobs = 'jobs',
  hotness = 'hotness',
  estimate = 'estimate',
  clockIn = 'clockIn',
  appNotifications = 'appNotifications',
}

export interface TrackerData {
  id: TimeLogId;
}

export interface HotnessData {
  id: OrgId;
  name: string;
  old: number;
  new: number;
}

export interface EstimateData {
  message: string;
}
export interface UserMessage {
  kind: MessageKind;
  data: TrackerData | HotnessData | EstimateData | JobResponse | GCNotification;
}
